// extracted by mini-css-extract-plugin
export var blink = "styles-module--blink--q6oCt";
export var icon = "styles-module--icon--cKi7U";
export var select_button = "styles-module--select_button---efMe";
export var select_content = "styles-module--select_content--7+Vvh";
export var select_content_wrapper = "styles-module--select_content_wrapper--vUruH";
export var select_default_content = "styles-module--select_default_content--dTKKa";
export var select_default_item = "styles-module--select_default_item--YDarM";
export var select_default_trigger = "styles-module--select_default_trigger--Ds0DM";
export var select_item = "styles-module--select_item--Zma5q";
export var select_item_indicator = "styles-module--select_item_indicator--qj-WL";
export var select_item_label = "styles-module--select_item_label--iE8Q-";
export var select_scroll_button = "styles-module--select_scroll_button--B5-5s";
export var select_separator = "styles-module--select_separator--riEpU";
export var select_trigger = "styles-module--select_trigger--qyOeO";